import React from 'react';

import VisibilitySensor from "react-visibility-sensor";
import {withTranslation} from "react-i18next";
const LoadMoreVisible = ({ setPage = () => {}, t }) => {
  return (
    <VisibilitySensor
      offset={{ bottom: -250 }}
      partialVisibility
      onChange={(isVisible) => {
        if(isVisible){
          setPage();
        }
      }}
    >
      {() => (
          <button
              type={"info"}
              onClick={setPage}
              style={{opacity: 0}}
          />
      )}
    </VisibilitySensor>
  );
};

export default withTranslation('main')(LoadMoreVisible);